import { stats } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Crowded%20city%20street%20at%20night%20with%20camera%20flashes%20and%20blurred%20silhouettes%20of%20paparazzi%2C%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20abstract%20editorial%20photography%2C%20heavy%20atmosphere%2C%20no%20identifiable%20faces%2C%20cinematic%20grain&width=1600&height=900&seq=psg-hero-main&orientation=landscape"
          alt="私照外泄事件报道封面氛围图"
          title="私照外泄 事件报道封面"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />
        <div className="grain-overlay absolute inset-0 opacity-40" />
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pb-20 pt-32 text-center md:px-8 md:pb-28 md:pt-44">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-wide text-background-100 backdrop-blur-sm md:text-sm">
            <span className="relative flex h-2 w-2 items-center justify-center">
              <span className="absolute inline-flex h-2 w-2 rounded-full bg-primary-400 animate-pulse-dot" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-400" />
            </span>
            全程深度追踪 · 持续更新中
          </span>
        </Reveal>

        <Reveal delay={80}>
          <h1 className="mt-7 font-heading text-4xl font-black leading-[1.1] tracking-tight text-background-50 md:text-6xl lg:text-7xl">
            私照外泄
          </h1>
        </Reveal>

        <Reveal delay={140}>
          <p className="mt-5 max-w-2xl text-balance text-base leading-relaxed text-background-100 md:text-lg">
            私照外泄事件全程汇总，现场细节、后续进展、内幕争议一网打尽。
            点开即看事件来龙去脉，吃瓜不迷路。
          </p>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#timeline"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto md:text-base"
            >
              <i className="ri-time-line text-lg" />
              查看完整时间线
            </a>
            <a
              href="#overview"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 bg-background-50/10 px-7 py-3.5 text-sm font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 sm:w-auto md:text-base"
            >
              <i className="ri-compass-3-line text-lg" />
              事件速览入口
            </a>
          </div>
        </Reveal>

        <Reveal delay={260} className="w-full">
          <dl className="mt-14 grid w-full grid-cols-2 gap-x-6 gap-y-8 border-t border-background-50/15 pt-9 md:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label} className="flex flex-col items-center">
                <dt className="font-heading text-3xl font-black text-background-50 md:text-4xl">
                  {item.value}
                  <span className="ml-1 text-base font-bold text-accent-400 md:text-lg">{item.suffix}</span>
                </dt>
                <dd className="mt-2 text-xs tracking-wide text-background-200 md:text-sm">{item.label}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </section>
  );
}